import { getCookie } from "cookies-next";
import {
  CSURF_TOKEN_COOKIE,
  CSURF_TOKEN_HEADER,
  USER_TOKEN_COOKIE
} from "rivals/shared/constants";

const getFetchHeaders = (): HeadersInit => {
  const requestHeaders: HeadersInit = new Headers();

  requestHeaders.set("Content-Type", "application/json");
  requestHeaders.set("Accept", "application/json");

  const csurfCookie = getCookie(CSURF_TOKEN_COOKIE);
  if (csurfCookie) {
    requestHeaders.set(CSURF_TOKEN_HEADER, csurfCookie);
  }

  const userToken = getCookie(USER_TOKEN_COOKIE);
  if (userToken) {
    requestHeaders.set("Authorization", `token ${userToken}`);
  }

  return requestHeaders;
};

export default getFetchHeaders;
